export default {
    title: 'italic',
    description: 'Italic',
    action: [ 'italic' ],
    icon: 'Italic',
};
